export default __webpack_public_path__ + "static/media/5a0973abd092d00001df9c0e_clock.99badb93.svg";